import deenkhaalis from '../assets/projects/deenkhaalis.png'
import yathrib from '../assets/projects/yathrib.jpg'
import ctlc from '../assets/projects/ctlc.jpg'

export const data=[
    {
        id:1,
        name:"Deen Khaalis",
        image:deenkhaalis,
        live:"https://www.deenkhaalis.com/",
        // live:"/",

    },
    {
        id:2,
        name:"Yathrib School",
        image:yathrib,
        live:"https://yathribschool.co.ke"
    },
    {
        id:3,
        name:"CTLC Management System",
        image:ctlc,
        live:"https://www.ctlc.co.ke/",
    },
    // {
    //     id:4,
    //     name:"React JS Application",
    //     image:Project2,
    //     github:"",
    //     live:"",
    // },


]